import { render, staticRenderFns } from "./RiskScoreIndicator.vue?vue&type=template&id=2dce814e&scoped=true"
import script from "./RiskScoreIndicator.vue?vue&type=script&lang=js"
export * from "./RiskScoreIndicator.vue?vue&type=script&lang=js"
import style0 from "./RiskScoreIndicator.vue?vue&type=style&index=0&id=2dce814e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dce814e",
  null
  
)

export default component.exports